import { Injectable, inject } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PlataformaModel } from '../model/plataforma-model';
import { PlataformaCardModel } from '../model/plataforma-card-model';
import { BaseDinamica } from '../model/plataforma/base-dinamica.model';
import { DadosBaseDinamica } from '../model/plataforma/dados-base-dinamica.model';

@Injectable({
  providedIn: 'root'
})
export class PlataformaService {
  private readonly http = inject(HttpClient);
  private readonly urlBase = `${environment.urlBase}/plataforma`;

  buscarPlataformas(): Observable<PlataformaModel[]> {
    return this.http.get<PlataformaModel[]>(this.urlBase);
  }

  buscarPlataformasDoGrupo(): Observable<PlataformaModel[]> {
    return this.http.get<PlataformaModel[]>(`${this.urlBase}/grupo`, {
      headers: { 'no-loading': 'true' },
    });
  }

  buscarBasesDinamicas(plataformaId: number): Observable<BaseDinamica[]> {
    return this.http.get<BaseDinamica[]>(`${this.urlBase}/${plataformaId}/bases`, {
      headers: { 'no-loading': 'true' },
    });
  }

  buscarDadosBase(setorVinculoBaseId: number, page: number, size: number): Observable<DadosBaseDinamica> {
    return this.http.get<DadosBaseDinamica>(
      `${this.urlBase}/base/${setorVinculoBaseId}/dados`,
      { params: { page, size }, headers: { 'no-loading': 'true' } }
    );
  }

  buscarCards(): Observable<PlataformaCardModel[]> {
    return this.http.get<PlataformaCardModel[]>(`${this.urlBase}/cards`);
  }

  salvarCard(card: PlataformaCardModel): Observable<PlataformaCardModel> {
    return this.http.post<PlataformaCardModel>(`${this.urlBase}/cards`, card);
  }

  inativarCard(plataformaId: number): Observable<void> {
    return this.http.delete<void>(`${this.urlBase}/cards/${plataformaId}`);
  }

  atualizarLogo(plataformaId: number, arquivo: File): Observable<PlataformaCardModel> {
    const formData = new FormData();
    formData.append('arquivo', arquivo);
    return this.http.post<PlataformaCardModel>(`${this.urlBase}/cards/${plataformaId}/logo`, formData, {
      headers: { 'hide-content-type': 'true' }
    });
  }
}
